"use strict"

import React, { useState } from "react"
import PropTypes from "prop-types"
import { useIntl } from "react-intl"

import { API_STATUS } from "../../../shared_components/widgets/utils"
import { logToServer } from "../../../ErrorBoundary"
import { addNewObject } from "../../../Loaders"
import ModalAlterInventoryItem from "./ModalAlterInventoryItem"

export default function ModalDepleteInventoryItem(props) {
  const intl = useIntl()
  const [status_submit, setStatusSubmit] = useState(null)

  const onSubmit_deplete = (e, info) => {
    e.preventDefault()

    setStatusSubmit(API_STATUS.LOADING)
    const final_info = {
      ...info,
      action: "depleted",
    }

    addNewObject(
      `/laboratory/inventory/inventory-item/${props.inventory_item.id}/adjust_quantity/`,
      final_info,
    )
      .then((_) => {
        setStatusSubmit(API_STATUS.SUCCESS)
        props.onSuccess()
      })
      .catch((error) => {
        logToServer(error)
        console.error(error)
        setStatusSubmit(null)
        alert(intl.formatMessage({ id: "inventory.unable_to_deplete" }))
      })
  }

  return (
    <ModalAlterInventoryItem
      onSubmit={(event, info) => onSubmit_deplete(event, info)}
      icon={"fa fa-minus"}
      btn_type={"btn-danger"}
      max_quantity={props.inventory_item.available_quantity}
      title_id={"stock.deplete"}
      quantity_msg_id={"stock.quantity.to.deplete"}
      reason_msg_id={"stock.deplete.reason"}
      status={status_submit}
      isDeplete
      {...props}
    />
  )
}

ModalDepleteInventoryItem.propTypes = {
  inventory_item: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
}
